module.exports = __webpack_public_path__ + "media/customizations/bellavara/logo-d53a74d5557f6d60544dd79781808b4f.png";